export const configurationMenus = () => ({
    Id: 13,
    id: `main-menu-2-all`,
    path: '/management/configuration/global-configurations/global',
    label: 'Configurations',
    Description: 'Configuration refers to the system resource settings that are assigned to a specific domains. It helps to improve the performance by adjusting these configurations.',
    isEnabled: true,
    svg: (
        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12.75 3.75H12V12H20.25V11.25C20.25 7.10786 16.8921 3.75 12.75 3.75ZM13.5 10.5V5.29642C16.214 5.63486 18.3651 7.78596 18.7036 10.5H13.5ZM4.5 13.5C4.5 10.4403 6.79027 7.91549 9.75 7.54642V14.25H16.4536C16.0845 17.2097 13.5597 19.5 10.5 19.5C7.18629 19.5 4.5 16.8137 4.5 13.5ZM10.5 6C6.35786 6 3 9.35786 3 13.5C3 17.6421 6.35786 21 10.5 21C14.6421 21 18 17.6421 18 13.5V12.75H11.25V6H10.5Z" />
            </g>
        </svg>
    ),

    subMenu: [
        {
            id: `coln-1-collections`,
            label: 'Global Configurations',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M21 5a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5zm-5 5a3 3 0 1 0-6 0 3 3 0 0 0 6 0zM7 5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1H7V5z" fill="#007BFF"></path>
                    </g>
                </svg>


            ),
            path: '/management/configuration/global-configurations/global',
            isEnabled: true,

        },
        
         {
            id: `coln-1-collections`,
            label: 'ONE Configurations',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M21 5a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5zm-5 5a3 3 0 1 0-6 0 3 3 0 0 0 6 0zM7 5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1H7V5z" fill="#007BFF"></path>
                    </g>
                </svg>


            ),
            path: '/management/configuration/one-configurations',
            isEnabled: true,

        },
        // {
        //     id: `coln-1-collections`,
        //     label: ' eApplications',
        //     svg: (
        //         <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        //             <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        //             <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        //             <g id="SVGRepo_iconCarrier">
        //                 <path fillRule="evenodd" clipRule="evenodd" d="M21 5a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5zm-5 5a3 3 0 1 0-6 0 3 3 0 0 0 6 0zM7 5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1H7V5z" fill="#007BFF"></path>
        //             </g>
        //         </svg>

        //     ),
        //     path: '/management/configurations/e-applications',
        //     isEnabled: true,

        // },
        // {
        //     id: `coln-1-collections`,
        //     label: ' Service Configurations',
        //     svg: (
        //         <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        //             <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        //             <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        //             <g id="SVGRepo_iconCarrier">
        //                 <path fillRule="evenodd" clipRule="evenodd" d="M21 5a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5zm-5 5a3 3 0 1 0-6 0 3 3 0 0 0 6 0zM7 5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1H7V5z" fill="#007BFF"></path>
        //             </g>
        //         </svg>

        //     ),
        //     path: '/management/configurations/services',
        //     isEnabled: true,

        // },
         {
            id: `coln-1-collections`,
            label: 'Sms Configurations',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm0 2v2l8 5 8-5V6H4zm16 10V8.32l-8 5-8-5V16h16z" />
                </svg>

            ),
            path: '/management/configuration/sms-configurations',
            isEnabled: true,

        },
        {
            id: `coln-1-collections`,
            label: ' EmailAccounts',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm0 2v2l8 5 8-5V6H4zm16 10V8.32l-8 5-8-5V16h16z" />
                </svg>

            ),
            path: '/management/configuration/email-accounts',
            isEnabled: true,

        },
        // {
        //     id: `coln-1-Categories`,
        //     label: 'Fulfillment',
        //     svg: (
        //         <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        //             <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        //             <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        //             <g id="SVGRepo_iconCarrier">
        //                 <path fillRule="evenodd" clipRule="evenodd" d="M21 5a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5zm-5 5a3 3 0 1 0-6 0 3 3 0 0 0 6 0zM7 5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1H7V5z" fill="#007BFF"></path>
        //             </g>
        //         </svg>

        //     ),
        //     path: '/management/configuration/fulfillment/fulfillment-providers',
        //     isEnabled: true,
        //     subMenu: [
        //         {
        //             id: `coln-1-collections`,
        //             label: 'Fulfillment Providers',
        //             svg: (
        //                 <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        //                     <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        //                     <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        //                     <g id="SVGRepo_iconCarrier">
        //                         <path fillRule="evenodd" clipRule="evenodd" d="M21 5a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5zm-5 5a3 3 0 1 0-6 0 3 3 0 0 0 6 0zM7 5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1H7V5z" fill="#007BFF"></path>
        //                     </g>
        //                 </svg>

        //             ),
        //             path: '/management/configuration/fulfillment/fulfillment-providers',
        //             isEnabled: true,

        //         }
        //     ],
        // },
        // {
        //     id: `coln-1-Categories`,
        //     label: 'Shipment',
        //     svg: (
        //         <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        //             <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        //             <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        //             <g id="SVGRepo_iconCarrier">
        //                 <path fillRule="evenodd" clipRule="evenodd" d="M4 6h16v4H4V6zm0 5h10v4H4v-4zm0 5h7v4H4v-4zm11-3a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" fill="#007BFF"></path>
        //             </g>
        //         </svg>

        //     ),
        //     path: '/management/configuration/shipment/delivery-dates',
        //     isEnabled: true,
        //     subMenu: [
        //         {
        //             id: `coln-1-collections`,
        //             label: 'Delivery Dates',
        //             svg: (
        //                 <svg className="h-6 w-6 fill-current mr-2"
        //                     xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        //                     <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778" />
        //                 </svg>

        //             ),
        //             path: '/management/configuration/shipment/delivery-dates',
        //             isEnabled: true,

        //         },
        //         {
        //             id: `coln-1-collections`,
        //             label: 'Measures',
        //             svg: (
        //                 <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        //                     <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        //                     <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        //                     <g id="SVGRepo_iconCarrier">
        //                         <path fillRule="evenodd" clipRule="evenodd" d="M18 3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm-1 9h-4V8h4v4zm-6-3H7v10h4V9zm6 7h-4v-4h4v4z" fill="#007BFF"></path>
        //                     </g>
        //                 </svg>

        //             ),
        //             path: '/management/configuration/shipment/measures',
        //             isEnabled: true,

        //         }
        //     ],
        // },
        {
            id: `coln-1-Categories`,
            label: 'Payment Management',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M21 5a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5zm-5 7H6v-2h10v2zm0 4H6v-2h10v2zm-8-5a1 1 0 0 1 0-2h6a1 1 0 1 1 0 2H8z" fill="#007BFF"></path>
                    </g>
                </svg>

            ),
            path: '/management/configuration/payment-management/payment-methods',
            isEnabled: true,
            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'Payment Methods',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M21 5a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5zm-5 7H6v-2h10v2zm0 4H6v-2h10v2zm-8-5a1 1 0 0 1 0-2h6a1 1 0 1 1 0 2H8z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                    path: '/management/configuration/payment-management/payment-methods',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'Payment Restrictions',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M21 5a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5zm-5 7H6v-2h10v2zm0 4H6v-2h10v2zm-8-5a1 1 0 0 1 0-2h6a1 1 0 1 1 0 2H8z" fill="#007BFF"></path>
                            </g>
                        </svg>
                    ),
                    path: '/management/configuration/payment-management/payment-restrictions',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'Tax Providers',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M21 5a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5zm-5 7H6V8h10v4zm-6 3h4v2H8v-2z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                    path: '/management/configuration/payment-management/tax-providers',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: ' Tax Categories',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M21 5a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5zm-5 7H6V8h10v4zm-6 3h4v2H8v-2z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                    path: '/management/configuration/payment-management/tax-categories',
                    isEnabled: true,

                },

            ],
        },

    ],
}
)
